/**
 * 用户相关请求模块
 */
import request, { post } from "@/utils/request";
import { postForm } from "@/utils/form";

export const login = (data) => {
    return request({
        method: "POST",
        url: "/app/v1_0/authorizations",
        data
    });
};

// 获得首页上的统计数据
export const HomeStat = (data) => {
    return request({
        method: "POST",
        url: "/Api/User/HomeStat",
        data
    });
};

// 注册用户
export const Register = (params) => {
    return request({
        method: "POST",
        url: "Api/User/Register",
        params
    });
};

// 获取当前用户账号的详细信息
export const UserInfo = (params) => {
    return request({
        method: "POST",
        url: "/Api/User/UserInfo",
        params
    });
};

// 获取管理员账号的详细信息
export const AdminUserInfo = (params) => {
    return request({
        method: "POST",
        url: "/Website/User/ManageUserInfo",
        params
    });
};

// 发送登录验证码
export const SendLoginCode = (params) => {
    const { currentStatus, ...otherProps } = params
    return request({
        method: "POST",
        url: currentStatus === "manage" ? "/Website/User/SendLoginCode" : "/Api/User/SendLoginCode",
        params: otherProps
    });
};

// 发送修改密码验证码
export const SendUpdatePassCode = (params) => {
    return request({
        method: "POST",
        url: "/Api/User/SendUpdatePassCode",
        params
    });
};

// 通过验证码重置密码
export const UpdatePassForTel2 = (params) => {
    return request({
        method: "POST",
        url: "/Api/User/ForgetPassForTeL",
        params
    });
};

// 获取用户消费记录
export const GetUserConsumeRecord = (params) => {
    return request({
        method: "POST",
        url: "/Api/User/GetUserConsumeRecord",
        params
    });
};

// 手机账号登录
export const TelLogin = (params) => {
    const { currentStatus, ...otherProps } = params
    return request({
        method: "POST",
        url: currentStatus === "manage" ? "/Website/User/TelLogin" : "/Api/User/TelLogin",
        params: otherProps
    });
};
// 获取章节价格
export const GetChapterPrice = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/GetProductByCategoryId",
        params
    });
};

// 账号登录
export const accountLogin = (params) => {
    return request({
        method: "POST",
        url: "/Api/User/UpinLogin",
        params
    });
};

// 管理员登录
export const ManageLogin = (params) => {
    return request({
        method: "POST",
        url: "/Website/User/ManageLogin",
        params
    });
};

// 退出登录
export const loginOut = (params) => {
    return request({
        method: "POST",
        url: "/Api/User/Logout",
        params
    });
};

// 更新密码
export const UpdatePassForTel = (params) => {
    return request({
        method: "POST",
        url: "/Api/User/UpdatePassForTel",
        params
    });
};

// 修改密码
export const UpdatePassForOldPass = (params) => {
    return request({
        method: "POST",
        url: "/Api/User/UpdatePassForOldPass",
        params
    });
};

// 发送注册验证码
export const SendRegCode = (params) => {
    return request({
        method: "POST",
        url: "/Api/User/SendRegCode",
        params
    });
};

// 发送重置密码验证码
export const SendPassCode = (params) => {
    return request({
        method: "POST",
        url: "/Api/User/SendPassCode",
        params
    });
};

// 未登录情况下  修改密码
export const ForgetPassForTeL = (params, currentStatus) => {
    return request({
        method: "POST",
        url: currentStatus === "manage" ? "/Api/User/ForgetPassForTeLTer" : "/Api/User/ForgetPassForTeL",
        params
    });
};

// 修改昵称
export const UpdateRealNameForTel = (params) => {
    return request({
        method: "POST",
        url: "/Api/User/UpdateRealNameForTel",
        params
    });
};

// 微信支付
export const wxPay = (params) => {
    return request({
        method: "POST",
        url: "/Api/WeiXinPay/Pay",
        params
    });
};

// 微信支付PC
export const wxPayPc = (params) => {
    return request({
        method: "POST",
        url: "/Api/WeiXinPay/PayPC",
        params
    });
};
// 支付宝PC支付
export const aliPayPc = (params) => {
    return request({
        method: "POST",
        url: "/Api/AliPay/Pay",
        params
    });
};

/// 查询微信支付状态
export const PayOrderStatus = (params) => {
    return request({
        method: "POST",
        url: "/Api/WeiXinPay/PayOrderStatus",
        params
    });
};

// 支付测试
export const payTest = (params) => {
    return request({
        method: "GET",
        url: "/Api/WeiXinPay/TestPay",
        params
    });
};

// 编辑用户（PC）
export const EditUser = (params) => {
    return request({
        method: "POST",
        url: "/Api/User/EditUserForPC",
        data: params
    });
};

// 验证该手机是否存在
export const TelephoneIsExist = (params) => {
    return request({
        method: "POST",
        url: "/Api/User/TelephoneIsExist",
        params
    });
};

// 首页合作机构
export const GetGroupUser = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/GetGroupUser",
        params
    });
};

// 更新用户组织层级
export function UpdateUserOrganLevel(params) {
    return postForm("/Api/User/UpdateUserOrganLevel", params);
}

// 用户组织层级更改申请
export function UserOrganLevelApply(params) {
    return postForm("/Api/User/UserOrganLevelApply", params);
}

// 获取用户组织层级信息
export function GetUserOrganLevelInfo(params) {
    return postForm("/Api/User/GetUserOrganLevelInfo", params);
}

// 修改密码（原密码）
// export function UpdatePwdForOldPwd(params) {
//   return post("/Api/User/UpdatePassForOldPass", params)
// }

export const UpdatePwdForOldPwd = (params) => {
    return request({
        method: "POST",
        url: "/Api/User/UpdatePassForOldPass",
        params
    });
};

// 验证旧手机发送短信发送短信
export function UpdateTelphoneSendMsg(params) {
    return postForm("/Website/user/UpdateTelphoneSendMsg", params);
}

// 更换手机号时验证旧手机
export function VerifyOldTelphone(params) {
    return postForm("/Website/user/VerifyOldTelphone", params);
}

// 绑定新手机号时发送验证码
export function BindTelphoneSendMsg(params) {
    return postForm("/Website/user/BindTelphoneSendMsg", params);
}

// 绑定新手机号时发送验证码
export function BindTelphone(params) {
    return postForm("/Website/user/BindTelphone", params);
}

// 获取用户模块
export const GetModularByUserId = (params) => {
    return request({
        method: "POST",
        url: "/Website/User/GetModularByUserId",
        params
    });
};

// 切换用户角色
export function changeUserRole (toAccountType) {
    return post("/Api/Organ/SwitchAccountToTeacherOrStudent", { toAccountType })
}

// 导入用户
export function importUser (fileUrl) {
    return post("/Website/Basic/ImportUser", { fileUrl }, false, { fileUrl })
}
// 获取用户是否绑定ip权限
export function userIsBindingOrg () {
    return post("/Api/User/GetIPAuthorize")
}

// 是否有权限答卷
export function isAuthorizedDoQuestionnaire (id) {
    return post("/Manage/Questionnaire/IsAnswerAuthority", { id })
}
// 课程增加欢迎度
export function addHotValue (SourceId) {
    return postForm("/Manage/CustomSource/AddHotValue", { SourceId })
}

// 获取图片验证码
export function GetBuildVerifyCode (SourceId) {
    return postForm("/Api/User/GetBuildVerifyCode", { SourceId })
}

// 发送验证码
export function SendRegCodeByCaptcha (params) {
    return request({
        method: "POST",
        url: "/Api/User/SendRegCodeByCaptcha",
        params,
    });
}

// 用户通过手机号参加考试
export function LoginByTel (params) {
    return request({
        method: "POST",
        url: "/Api/User/LoginByTel",
        params,
    });
}

// 更新用户机构绑定
export function UpdateGroupUserId (params) {
    return request({
        method: "POST",
        url: "/Api/User/UpdateGroupUserId",
        params,
    });
}
